import type { QueryKey } from "@tanstack/react-query";

/** Query-key factory for staff Prelead reads. Every Prelead read registers
 *  under `preleadKeys.all` so a single prefix invalidation covers
 *  list + stats + detail + activity. */
export const preleadKeys = {
  all: ["leadgen-preleads"] as const,
  list: (filters: Record<string, unknown>): QueryKey => [...preleadKeys.all, "list", filters],
  stats: (filters: Record<string, unknown>): QueryKey => [...preleadKeys.all, "stats", filters],
  windowedStats: (filters: Record<string, unknown>): QueryKey => [...preleadKeys.all, "windowed-stats", filters],
  detail: (id: string): QueryKey => [...preleadKeys.all, "detail", id],
  earnings: (id: string): QueryKey => [...preleadKeys.all, "earnings", id],
  activity: (id: string): QueryKey => [...preleadKeys.all, "activity", id],
  notes: (id: string): QueryKey => [...preleadKeys.all, "notes", id],
  attachments: (id: string): QueryKey => [...preleadKeys.all, "attachments", id],
  /** The source prelead for a lead, fetched via the Leads.Read endpoint (Area A).
   *  Keyed by leadId (not preleadId) since that's the route. */
  sourceForLead: (leadId: string): QueryKey => [...preleadKeys.all, "source-for-lead", leadId],
};
